import styled from 'styled-components';

export const Div = styled.div`
  .btn-back {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    gap: 13px;
    grid-gap: 13px;
  }

  .back-hit-slop {
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      position: absolute;
      content: '';
      width: 80px;
      height: 80px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .back-hit-slop {
      &::before {
        width: 60px;
        height: 60px;
      }
    }
  }
`;

export const Twb = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 20px;

  svg {
    transform: translateY(2px);
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-gap: 10px;

    svg {
      transform: translateY(1px);
      width: 14px;
      height: 14px;
    }
  }
`;
